// src/stores/timelineActivityStore.ts
import { defineDocStore } from '@/stores/base/baseDocStore'
import { FilterMatchMode } from '@primevue/core/api'
import { TimelineActivityModel } from '@/models/TimelineActivityModel'
import type { TimelineActivity } from '@/types/TimelineActivity'

// Define default filters and sort order
export const defaultFilters = {
  global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  type: { value: null, matchMode: FilterMatchMode.EQUALS },
  personId: { value: null, matchMode: FilterMatchMode.EQUALS },
  organizationId: { value: null, matchMode: FilterMatchMode.EQUALS },
  userId: { value: null, matchMode: FilterMatchMode.EQUALS },
  createdAt: { value: null, matchMode: FilterMatchMode.DATE_IS },
}

export const defaultSort = {
  field: 'createdAt',
  order: -1,
}

// Create the timeline activity store using the base document store
export const useTimelineActivityStore = defineDocStore<TimelineActivity>({
  entityName: 'timelineActivity',
  collection: 'timeline_activities',
  model: TimelineActivityModel,
  initialState: {
    filters: defaultFilters,
    sort: defaultSort,
  },
})

// Re-export TimelineActivity type for convenience
export type { TimelineActivity } from '@/types/TimelineActivity'
